export const IllustrationProperties = ({ width = 388, height = 195 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 388 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_472_3504)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.9302 144.965C73.764 144.965 66.6187 149.475 62.9116 156.134C61.2462 155.382 59.3658 154.953 57.378 154.953C49.9103 154.953 43.7856 161.02 43.7856 168.538C43.7856 168.807 43.7856 169.129 43.8394 169.397C42.0665 168.431 40.0249 167.84 37.8759 167.84C31.3215 167.84 26.0565 172.888 26.0565 179.17C26.0565 179.546 26.0565 179.922 26.1102 180.352C25.1432 179.976 24.0687 179.815 22.9404 179.815C17.7829 179.815 13.5923 184.003 13.5923 189.158C13.5923 191.145 14.237 193.024 15.3115 194.528H111.479V158.819C111.371 158.819 111.21 158.819 111.103 158.819C108.094 158.819 105.3 159.624 102.937 161.074C100.465 151.731 91.9767 144.965 81.9302 144.965Z"
          fill="#FFB133"
        />
        <path
          d="M68.553 194.581C68.8216 193.776 69.3052 193.131 69.7887 192.648L81.9305 182.929C82.5752 182.392 82.6826 181.425 82.1991 180.781C81.6618 180.136 80.6948 180.029 79.9964 180.512L70.2722 188.298C69.8961 188.621 69.4126 188.674 68.9828 188.46C68.553 188.245 68.2844 187.815 68.2844 187.332V178.042C68.2844 177.076 68.4993 176.216 69.0365 175.411L74.7851 165.692C75.2149 164.94 75 164.027 74.2478 163.544C73.4957 163.114 72.5824 163.383 72.0988 164.081L67.586 171.652C67.3711 172.028 66.995 172.243 66.5652 172.243C66.1354 172.243 65.7593 172.082 65.4907 171.706L61.8374 166.443C61.3539 165.745 60.3868 165.584 59.6884 166.068C58.99 166.551 58.8288 167.517 59.3124 168.216L64.255 175.25C64.8997 176.163 65.2221 177.129 65.2221 178.257V182.231C65.2221 182.714 65.0072 183.09 64.5774 183.305C64.1476 183.519 63.7178 183.519 63.288 183.251L53.4564 177.076C52.7579 176.592 51.7909 176.807 51.3074 177.559C50.8239 178.257 51.0387 179.224 51.7909 179.707L63.9864 187.386C64.8997 187.976 65.1683 189.265 65.1683 190.178V194.527H68.553V194.581Z"
          fill="#0F538D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.645 109.525L149.247 82.5684L178.85 109.525V194.582H149.247H119.645V109.525Z"
          fill="#CBCBCB"
        />
        <path
          d="M168.535 120.425H152.901V143.891H168.535V120.425Z"
          fill="#4087BC"
        />
        <path
          d="M161.228 120.425H160.261V143.891H161.228V120.425Z"
          fill="white"
        />
        <path
          d="M168.535 131.701H152.901V132.668H168.535V131.701Z"
          fill="white"
        />
        <path
          d="M145.594 120.425H129.96V143.891H145.594V120.425Z"
          fill="#4087BC"
        />
        <path
          d="M138.287 120.425H137.32V143.891H138.287V120.425Z"
          fill="white"
        />
        <path
          d="M145.594 131.701H129.96V132.668H145.594V131.701Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.645 109.525H86.0135L115.616 82.5684H149.248L119.645 109.525Z"
          fill="#2B63A4"
        />
        <path
          d="M119.699 109.524H86.0135V194.528H119.699V109.524Z"
          fill="#CCE9FF"
        />
        <path
          d="M108.524 120.425H96.9729V143.891H108.524V120.425Z"
          fill="#4087BC"
        />
        <path
          d="M103.152 120.425H102.399V143.891H103.152V120.425Z"
          fill="white"
        />
        <path
          d="M108.524 131.701H96.9729V132.668H108.524V131.701Z"
          fill="white"
        />
        <path
          d="M168.535 156.832H152.901V180.298H168.535V156.832Z"
          fill="#4087BC"
        />
        <path
          d="M161.228 156.832H160.261V180.298H161.228V156.832Z"
          fill="white"
        />
        <path
          d="M168.535 168.108H152.901V169.075H168.535V168.108Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M153.545 100.288V106.624H144.949V100.288C144.949 97.9253 146.883 95.9922 149.247 95.9922C151.665 95.9922 153.545 97.9253 153.545 100.288Z"
          fill="#4087BC"
        />
        <path
          d="M144.627 157.423H130.927V172.19H144.627V157.423Z"
          fill="#4087BC"
        />
        <path
          d="M138.287 156.725H137.32V173.264H138.287V156.725Z"
          fill="white"
        />
        <path
          d="M145.594 164.35H129.96V165.316H145.594V164.35Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.346 155.758V191.843H129.208V155.758H146.346ZM130.927 157.422V172.189H144.627V157.422H130.927Z"
          fill="#2B63A4"
        />
        <path
          d="M108.524 156.832H96.9729V180.298H108.524V156.832Z"
          fill="#4087BC"
        />
        <path
          d="M103.152 156.832H102.399V180.298H103.152V156.832Z"
          fill="white"
        />
        <path
          d="M108.524 168.108H96.9729V169.075H108.524V168.108Z"
          fill="white"
        />
        <path
          d="M119.699 74.4062H115.992V95.0799H119.699V74.4062Z"
          fill="#F0F0F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M127.166 74.4062H119.752V95.0799L127.166 89.0657V74.4062Z"
          fill="#CBCBCB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M210.171 148.724L192.711 121.714L175.197 148.724V194.582H192.711H210.171V148.724Z"
          fill="#CBCBCB"
        />
        <path
          d="M280.282 148.724H210.171V194.582H280.282V148.724Z"
          fill="#CCE9FF"
        />
        <path
          d="M267.495 160.913H253.795V181.426H267.495V160.913Z"
          fill="#4087BC"
        />
        <path
          d="M261.102 160.913H260.243V181.426H261.102V160.913Z"
          fill="white"
        />
        <path
          d="M267.495 170.739H253.795V171.598H267.495V170.739Z"
          fill="white"
        />
        <path
          d="M236.657 160.913H223.011V181.426H236.657V160.913Z"
          fill="#4087BC"
        />
        <path
          d="M230.264 160.913H229.405V181.426H230.264V160.913Z"
          fill="white"
        />
        <path
          d="M236.657 170.739H223.011V171.598H236.657V170.739Z"
          fill="white"
        />
        <path
          d="M197.761 160.913H187.661V181.426H197.761V160.913Z"
          fill="#4087BC"
        />
        <path
          d="M193.033 160.913H192.388V181.426H193.033V160.913Z"
          fill="white"
        />
        <path
          d="M197.761 170.739H187.661V171.598H197.761V170.739Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M280.336 148.724H210.171L192.818 121.982H262.929L280.336 148.724Z"
          fill="#2B63A4"
        />
        <path
          d="M197.761 142.816H187.661V149.529H197.761V142.816Z"
          fill="#4087BC"
        />
        <path
          d="M241.224 112.961H237.517V133.635H241.224V112.961Z"
          fill="#CBCBCB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M230.049 112.961H237.517V133.635L230.049 124.345V112.961Z"
          fill="#F1E3CA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.715 109.525L321.113 82.5684L291.51 109.525V194.582H321.113H350.715V109.525Z"
          fill="#F9DA78"
        />
        <path
          d="M317.459 120.425H301.825V143.891H317.459V120.425Z"
          fill="#4087BC"
        />
        <path
          d="M310.099 120.425H309.132V143.891H310.099V120.425Z"
          fill="white"
        />
        <path
          d="M317.459 131.701H301.825V132.668H317.459V131.701Z"
          fill="white"
        />
        <path
          d="M340.4 120.425H324.766V143.891H340.4V120.425Z"
          fill="#4087BC"
        />
        <path
          d="M333.04 120.425H332.073V143.891H333.04V120.425Z"
          fill="white"
        />
        <path
          d="M340.4 131.701H324.766V132.668H340.4V131.701Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.715 109.525H384.401L354.744 82.5684H321.113L350.715 109.525Z"
          fill="#0F538D"
        />
        <path
          d="M384.4 109.524H350.715V194.528H384.4V109.524Z"
          fill="#FFBE55"
        />
        <path
          d="M373.387 120.425H361.836V143.891H373.387V120.425Z"
          fill="#4087BC"
        />
        <path
          d="M368.014 120.425H367.262V143.891H368.014V120.425Z"
          fill="white"
        />
        <path
          d="M373.387 131.701H361.836V132.668H373.387V131.701Z"
          fill="white"
        />
        <path
          d="M317.459 156.832H301.825V180.298H317.459V156.832Z"
          fill="#4087BC"
        />
        <path
          d="M310.099 156.832H309.132V180.298H310.099V156.832Z"
          fill="white"
        />
        <path
          d="M317.459 168.108H301.825V169.075H317.459V168.108Z"
          fill="white"
        />
        <path
          d="M340.4 156.832H324.766V180.298H340.4V156.832Z"
          fill="#4087BC"
        />
        <path
          d="M333.04 156.832H332.073V180.298H333.04V156.832Z"
          fill="white"
        />
        <path
          d="M340.4 168.108H324.766V169.075H340.4V168.108Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M369.949 86.5421L359.58 78.9707L349.211 86.5421V102.222H369.949V86.5421Z"
          fill="#FFBE55"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M337.552 86.542H349.211V102.222L337.552 91.5896V86.542Z"
          fill="#F9DA78"
        />
        <path
          d="M364.361 87.0781H354.744V97.2807H364.361V87.0781Z"
          fill="#4087BC"
        />
        <path
          d="M359.902 87.0781H359.311V97.2807H359.902V87.0781Z"
          fill="white"
        />
        <path
          d="M364.361 91.8584H354.744V92.4491H364.361V91.8584Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M359.58 78.9707H347.921L337.552 86.5421H349.211L359.58 78.9707Z"
          fill="#0F538D"
        />
        <path
          d="M327.022 98.2471H315.149V108.342H327.022V98.2471Z"
          fill="#4087BC"
        />
        <path
          d="M321.435 98.2471H320.791V108.342H321.435V98.2471Z"
          fill="white"
        />
        <path
          d="M327.184 102.973H314.988V103.617H327.184V102.973Z"
          fill="white"
        />
        <path
          d="M374.461 157.423H360.762V172.19H374.461V157.423Z"
          fill="#4087BC"
        />
        <path
          d="M368.122 156.725H367.155V173.264H368.122V156.725Z"
          fill="white"
        />
        <path
          d="M375.428 164.35H359.794V165.316H375.428V164.35Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M376.181 155.758V191.843H359.043V155.758H376.181ZM360.762 157.422V172.189H374.462V157.422H360.762Z"
          fill="#2B63A4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M278.831 98.9463C268.731 98.9463 256.589 108.88 251.485 129.124C246.435 149.422 251.915 169.398 278.401 169.398C304.941 169.398 309.938 153.127 307.789 134.118C305.693 115.217 288.931 98.9463 278.831 98.9463Z"
          fill="#FFB133"
        />
        <path
          d="M281.034 194.581V164.779C281.034 163.221 281.464 161.879 282.431 160.644L296.937 141.581C297.528 140.83 297.366 139.756 296.614 139.219C295.862 138.628 294.841 138.789 294.25 139.541L283.452 153.663C282.646 154.684 281.034 154.147 281.034 152.858V138.95C281.034 138.037 281.195 137.285 281.518 136.426L287.105 122.519C287.965 120.424 284.795 119.189 283.989 121.23L280.604 129.714C280.121 130.842 278.563 130.842 278.079 129.714L272.814 116.934C271.955 114.894 268.839 116.182 269.698 118.223L277.166 136.426C277.542 137.285 277.649 138.091 277.649 139.004V149.099C277.649 150.334 276.145 150.925 275.286 150.012L261.747 135.513C260.243 133.903 257.718 136.212 259.276 137.822L275.823 155.596C277.058 156.885 277.649 158.442 277.649 160.214V194.581H281.034Z"
          fill="#2B63A4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M217.693 38.4745C225.859 34.6619 232.359 38.9577 237.678 44.4349C190.186 45.2941 142.639 46.0995 95.1465 46.9587C101.217 38.7429 111.049 34.0712 119.376 38.8503C120.988 29.131 126.468 25.7481 135.977 29.0774C132.324 0.993436 174.981 -4.80592 181.536 23.5465C185.619 14.2031 206.249 14.4716 204.476 32.4603C207.431 23.3317 223.387 26.9294 217.693 38.4745Z"
          fill="#F4F9FE"
        />
      </g>
      <defs>
        <clipPath id="clip0_472_3504">
          <rect
            width="388"
            height="195"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
